import React from "react";

const BulletBlur = ({...rest}) => {
    return (
        <svg 
            width="9" 
            height="9" 
            viewBox="0 0 9 9" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <circle cx="4.3335" cy="4.5" r="4" fill="#99A9F7" />
        </svg>
    );
}

export default BulletBlur;
